module.exports = __webpack_public_path__ + "media/newstyle/images/mood_heart-82d2ddc232e1c4790d6eb5f00cb2d804.svg";